<template>
  <v-container fluid>
    <v-layout column>

      <!-- Input File -->
      <v-flex xs12>
        <v-file-input
          id="media-upload"
          small-chips
          multiple
          counter
          accept="image/*"
          label="File Upload"
          placeholder="Seleziona una o più immagini"
          class="pa-5"
          v-model="files"
          @change="change($event)"
          :disabled="loading"
        ></v-file-input>
      </v-flex><!-- /Input File -->

      <!-- Cards -->
      <v-flex
        xs12
        v-for="(file, index) in meta"
        :key="index"
      >

        <v-card class="ma-5">

          <!-- Header -->
          <v-card-title class="accent--text">{{file.oldName}}</v-card-title>
          <v-card-text>
            {{index + 1}} di {{meta.length}} | Dimensione: {{file.size}}
            <br><br>
            <v-divider></v-divider>
            <br><!-- Header -->

            <!-- Form -->
            <v-container fluid>
              <v-layout row>
                <!-- Img Preview -->
                <v-flex
                  xs2
                  class="pr-2"
                >
                  <v-img
                    class="img-preview"
                    :src="file.src"
                  ></v-img>
                </v-flex><!-- /Img Preview -->
                <!-- Inputs -->
                <v-flex
                  xs10
                  class="pl-2"
                >
                  <v-text-field
                    v-model="meta[index].newName"
                    label="Nome del file (senza estenzione)"
                    :disabled="loading"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="meta[index].alt"
                    label="Testo alternativo del file"
                    :disabled="loading"
                    required
                  ></v-text-field>
                </v-flex><!-- /Inputs -->
              </v-layout>
            </v-container><!-- /Form -->
          </v-card-text>
        </v-card>
      </v-flex><!-- /Cards -->

      <!-- Submit -->
      <v-flex xs12>
        <v-btn
          v-if="meta.length > 0"
          color="primary"
          block
          class="mt-5"
          :loading="loading"
          @click="uploadMedia"
        >
          <v-icon>mdi-upload</v-icon> Carica Media
        </v-btn>
      </v-flex><!-- Submit -->
    </v-layout>

    <!-- Snackbar -->
    <v-snackbar
      right
      multi-line
      :color="snackbarColor"
      v-model="snackbar"
    >
      <b>
        <span v-if="errors">Upload fallito...</span>
        <span v-else>Upload riuscito!</span>
      </b>
      <v-btn
        text
        @click="snackbar = false"
      >
        Chiudi
      </v-btn>
    </v-snackbar><!-- /Snackbar -->

  </v-container>
</template>

<script>
  export default {
    name: 'MediaUpload',
    data() {
      return {
        files: [],
        meta: [],
        loading: false,
        errors: false,
        snackbar: false,
      }
    },
    methods: {
      uploadMedia() {

        this.loading = true

        let formData = new FormData();

        this.files.forEach((file, index) => {
          formData.append('files[' + index + ']', file);
        })

        formData.append('meta', JSON.stringify(this.meta))

        this.$store.dispatch('uploadMedia', { body: formData })
          .then(data => {
            if (data.status === 200) {
              this.errors = false
              this.files = []
              this.meta = []
              this.$store.dispatch('fetchMedia')
            } else {
              this.errors = true
            }

            this.snackbar = true
          })
          .then(this.loading = false)
      },
      change(e) {
        this.meta = []

        e.forEach((element, index) => {

          let reader = new FileReader();

          reader.addEventListener("load", () => {
            this.meta.push({ oldName: element.name, newName: this.removeExtension(element.name), size: this.convertBytes(element.size), alt: this.removeExtension(element.name), src: reader.result })
          }, false);

          reader.readAsDataURL(element);
        });
      },
      convertBytes(bytes) {
        if (bytes < 1000) {
          return `${bytes} B`
        } else if (bytes >= 1000 && bytes < 1000000) {
          return `${Math.round(bytes / 1000)} KB`
        } else {
          return `${Math.round(bytes / 1000000)} MB`
        }
      },
      removeExtension(name) {
        return name.replace(/\.[^/.]+$/, "")
      }
    },
    computed: {
      snackbarColor() {
        return this.errors ? 'pink' : 'primary'
      }
    }
  }
</script>

<style scoped>
  .img-preview {
    border-radius: 3px;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }
</style>
